/* eslint-disable @typescript-eslint/no-redeclare */

export type KYX_CHECK_REVIEW_STATUS =
  | 'PENDING'
  | 'VALIDATED'
  | 'SENT_FOR_PRECHECK'
  | 'SENT_TO_TREEZOR'
  | 'SENT_FOR_POSTCHECK'
  | 'PRECHECKED'
  | 'INVALID'
  | 'REFUSED'
  | 'NONE';

export const KYX_CHECK_REVIEW_STATUS: {
  [reviewStatus in KYX_CHECK_REVIEW_STATUS]: reviewStatus;
} = {
  INVALID: 'INVALID',
  NONE: 'NONE',
  PENDING: 'PENDING',
  PRECHECKED: 'PRECHECKED',
  REFUSED: 'REFUSED',
  SENT_FOR_POSTCHECK: 'SENT_FOR_POSTCHECK',
  SENT_FOR_PRECHECK: 'SENT_FOR_PRECHECK',
  SENT_TO_TREEZOR: 'SENT_TO_TREEZOR',
  VALIDATED: 'VALIDATED',
};

export type KYX_CHECK_STATUS =
  | 'COMPLETED'
  | 'PENDING'
  | 'SUBMITTED'
  | 'EXPIRED';

export const KYX_CHECK_STATUS: {
  [status in KYX_CHECK_STATUS]: status;
} = {
  COMPLETED: 'COMPLETED',
  EXPIRED: 'EXPIRED',
  PENDING: 'PENDING',
  SUBMITTED: 'SUBMITTED',
};

export const ESTABLISHMENT = {
  AGENT: 'AGENT',
  EP: 'EP',
};
